export default class NotificationSettings {
  constructor(
    json = {
      notificationLevel: 'AmiAndDealer',
      notificationSchedule: 'Immediately',
      personalizedMessage: '',
      secondaryDealerRecipientIds: [],
      otherRecipients: '',
      includeCurrentUser: true,
    }
  ) {
    this.notificationLevel = json.notificationLevel;
    this.notificationSchedule = json.notificationSchedule;
    this.secondaryDealerRecipientIds = json.secondaryDealerRecipientIds || [];
    this.otherRecipients = json.otherRecipients;
    this.personalizedMessage = json.personalizedMessage || '';
    this.includeCurrentUser = json.includeCurrentUser;
  }
  clone() {
    return new NotificationSettings({ ...this });
  }
}
